<template>
  <div id="rules" class="pr-3 pl-3 pt-3 pb-3 m-auto center-container">
    <div class="bg-light-primary">
      <div class="d-flex flex-column">
          <p class="h5 font-weight-bold text-center pt-3 pb-2">
            Les règles
          </p>
        <div class="bg-white mr-3 ml-3 mb-3 pl-2 pr-2 pb-3 pt-3">
          <p class="font-weight-bold mb-0 mt-0">
            Pour commencer
          </p>
          <p class="text-black-50 mb-0 mt-0 pb-2 pt-2">
            Choisissez si vous jouez tous ensemble ou en groupe de 2 ou 3 personnes, dans çe cas, créez les groupes selon une règle aléatoire (ex: Le joueur doit expliquer l'opposé de son intention)
          </p>
          <p class="font-weight-bold mb-0 mt-0">
            Début du jeu
          </p>
          <p class="text-black-50 mb-0 mt-0 pb-2 pt-2">
            Dans chaque groupe, un joueur tire une carte, lit la question, y répond et propose aux autres d'y répondre, une foi l'echange terminé, le joueur suivant reproduit le même méchanisme
          </p>
          <p class="font-weight-bold mb-0 mt-0">
            Fin
          </p>
          <p class="text-black-50 mb-0 mt-0 pb-2 pt-2">
            A la fin du temps imparti, faites un retour sur votre impression et sur l'expérience vécue !
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rules'
}
</script>


<style>
  .bg-light-primary {
    background-color: #E0F3F4;
    line-height: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/RulesComponent.vue